import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {FormGroup, Input, Label} from 'reactstrap';
import oitsActionCreators from '../../store/oits/action-creators/index';
import AvailableFtoCard from './AvailableFtoCard';
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class AssignFtoGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterByName: '',
      filteredFtos: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ftos) {
      this.setState({ filteredFtos: nextProps.ftos });
    }
  }

  filterByName(characters) {
    const filteredFtos = this.props.ftos.filter((fto) => {
      return fto
        .getFullNameReversed()
        .toLowerCase()
        .includes(characters.toLowerCase());
    });
    this.setState({ filteredFtos, filterByName: characters });
  }

  // ----------------------
  // Methods
  // ----------------------

  assignFto(ftoGuid) {
    const formData = {
      ftoGuid,
      trainingPhaseGuid: this.props.isAssigningFtoFor,
    };
    this.props.assignFtoToPhase(formData);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <form className="column">
          <FormGroup>
            <Label for="filterByName">Filter by Name:</Label>
            <Input
              disabled={!this.props.ftos}
              onChange={event => this.filterByName(event.target.value)}
              name="filterByName"
              placeholder={`Search ${this.props.ftoShortLabel}`}
              value={this.state.filterByName}
            />
          </FormGroup>
        </form>
        {this.state.filteredFtos.map(fto => (
          <AvailableFtoCard
            fto={fto}
            key={fto.guid}
            onAssign={ftoGuid => this.assignFto(ftoGuid)}
          />
        ))}
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isAssigningFtoFor: state.oits.isAssigningFtoFor,
    ftos: state.ftos.list,
    selectedGuid: state.oits.selectedGuid,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    assignFtoToPhase: (formData) => {
      return dispatch(oitsActionCreators.assignFtoToPhase(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignFtoGrid);
